<template>
    <div class="error" v-if="hasMessages">
        <p v-for="message in messages">{{ message }} </p>
    </div>
</template>

<script>
	export default {
		name: "ErrorMessage",
        props: {
			messages: {
				type: Array,
				default: function () {
					return []
				}
            }
        },
        computed: {
			hasMessages() {
				return this.messages.length
            }
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/common/ErrorMessage.vue